/* eslint-disable no-unused-vars */
import ApiService from "../api.service";
import appConfig from "../../../app-config";

ApiService.init(appConfig.VUE_APP_ROOT_API);

const StockAdjustmentReviewService = {
  dataSourceConfig(params) {
    var url = "api/StockAdjustmentDetail";
    return ApiService.createDataSource(url, params);
  },
  async getByCode(code) {
    const requestScreenData = {
      url: "api/StockAdjustment",
      top: "1",
      filter: `Code eq ${code}`,
    };

    return await ApiService.oDataGet(requestScreenData);
  },
};

export { StockAdjustmentReviewService };
